import { render, staticRenderFns } from "./cloud-disk.vue?vue&type=template&id=1cd0fc74&scoped=true"
import script from "./cloud-disk.vue?vue&type=script&lang=js"
export * from "./cloud-disk.vue?vue&type=script&lang=js"
import style0 from "./cloud-disk.vue?vue&type=style&index=0&id=1cd0fc74&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd0fc74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/6888b5b9-9128-43f9-bb48-628a7d9749d7/workspace/Knowledge-base_jo8K/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cd0fc74')) {
      api.createRecord('1cd0fc74', component.options)
    } else {
      api.reload('1cd0fc74', component.options)
    }
    module.hot.accept("./cloud-disk.vue?vue&type=template&id=1cd0fc74&scoped=true", function () {
      api.rerender('1cd0fc74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/cloud-disk/src/cloud-disk.vue"
export default component.exports